import { render, staticRenderFns } from "./SectionProps.vue?vue&type=template&id=a7af05f4"
import script from "./SectionProps.vue?vue&type=script&lang=js"
export * from "./SectionProps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports